import {
    EntryTypeItemPresentationData,
    EntryTypeItemPresentationListResponse,
    EntryTypeItemPresentationUpdateForm,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/entry-type-item-presentation';

export class EntryTypeItemPresentationApi {
    public static async update(
        userId: string,
        itemId: string,
        { entryId, entryTypeItemPresentation }: EntryTypeItemPresentationUpdateForm,
    ): Promise<void> {
        await axios.put(`${BASE_URL}/${userId}/${itemId}`, { entryId, entryTypeItemPresentation });
    }

    public static async getList(subjectId: string): Promise<EntryTypeItemPresentationData[]> {
        const res = await axios.get<EntryTypeItemPresentationListResponse>(`${BASE_URL}/${subjectId}`);

        return res.data.entryTypeItemPresentationList;
    }
}
